<template>
  <div class="content-wrapper">
    <app-overlay-loader v-if="preloader" />
    <div class="row" :class="{ 'loading-opacity': preloader }">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Demora en el Proceso"
          directory=""
          :icon="'trello'"
        />
      </div>
      
    </div>
    <div class="col-md-12">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
          preloader: false,
          icon: "settings",
          tabsHorizontal: [
            {
              icon: "briefcase",
              name: "Procesos en curso",
              component: "process-delays-inprogress",
              permission: "",
            },
            {
              icon: "briefcase",
              name: "Procesos finalizados",
              component: "process-delays-finished",
              permission: "",
            },
          ],
        }
    }
}
</script>

<style>

</style>